import type { Module } from 'vuex';

import { locales } from './../../locales/index';
import { actions } from './actions';
import { getters } from './getters';
import type { CitiesState } from './interfaces';
import { mutations } from './mutations';

export const App: Module<any, any> = {
  actions,
  mutations,
  getters,
  state: {
    isLoading: true,
    translations: locales.en,
    brokerData: {},
    countries: [],
    provinces: [],
    cities: [] as CitiesState,
    brand: '',
  },
} as const;
